/* zoo-marken.js — Suche, Filter-Chips und Aufklapptext der Markenübersicht. */
(function () {
  function norm(s) {
    return (s || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function init(root) {
    if (!root || root.dataset.zmReady) return;
    root.dataset.zmReady = '1';

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-group]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-brand]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var field = root.querySelector('[data-search]');
    var box = root.querySelector('.zm__search');
    var clear = root.querySelector('[data-clear]');
    var count = root.querySelector('[data-count]');
    var filter = 'all';

    cards.forEach(function (c) { c.dataset.key = norm(c.dataset.brand + ' ' + (c.dataset.claim || '')); });

    function apply() {
      var q = norm(field ? field.value : '');
      groups.forEach(function (g) {
        var on = filter === 'all' || g.dataset.group === filter;
        var shown = 0;
        Array.prototype.slice.call(g.querySelectorAll('[data-brand]')).forEach(function (c) {
          var match = on && (!q || c.dataset.key.indexOf(q) > -1);
          c.hidden = !match;
          if (match) shown++;
        });
        g.hidden = shown === 0;
        var gc = g.querySelector('[data-group-count]');
        if (gc) gc.textContent = shown === 1 ? '1 Marke' : shown + ' Marken';
      });
      var uniq = {};
      cards.forEach(function (c) { if (!c.hidden) uniq[c.dataset.brand] = 1; });
      var n = Object.keys(uniq).length;
      root.classList.toggle('is-empty', n === 0);
      if (count) count.textContent = n === 1 ? '1 Marke' : n + ' Marken';
      if (box) { if (field && field.value) { box.setAttribute('data-filled', ''); } else { box.removeAttribute('data-filled'); } }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.dataset.filter;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        apply();
      });
    });
    if (field) field.addEventListener('input', apply);
    if (clear) clear.addEventListener('click', function () { field.value = ''; field.focus(); apply(); });

    apply();
  }

  function initCopy(el) {
    var btn = el.querySelector('[data-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.textContent = open ? btn.dataset.less || 'Weniger anzeigen' : btn.dataset.more || 'Weiterlesen';
      btn.setAttribute('aria-expanded', String(open));
    });
  }

  function boot() {
    document.querySelectorAll('.zm').forEach(init);
    document.querySelectorAll('.zm__copy').forEach(initCopy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
